<script>
    import {onMount} from "svelte";
    import {customFetch} from "../customFetch";
    import {levelsUrl} from "../urls";
    import {notifications} from "../notifications";
    import RoundWrapper from "../components/RoundWrapper.svelte";
    import {binaryView, dateView, labelView, valueView, saveRows} from "../tableUtils";
    import StraightTable from "../components/StraightTable.svelte";

    let rows = []
    let originalRows = {}

    async function load() {
        try {
            let response = await customFetch(levelsUrl());
            rows = await response.json();
            for (let i = 0; i < rows.length; i++) {
                rows[i].UpdatedAt = new Date(rows[i].UpdatedAt)
            }
        } catch (e) {
            notifications.danger(
                `Error loading levels: ${e.message}`
            );
        }
    }

    async function save(e) {
        const rows = e.detail.data;
        let fields = columns.map(elem => elem.field);
        await saveRows(rows, fields, levelsUrl());
        await load();
    }

    let columns = [
        {title: 'ID', field: 'ID', sortable: true, defaultValue: null, editView: labelView},
        {title: 'Index', field: 'Index', sortable: true, defaultValue: null, editView: valueView("number", 1, 0)},
        {title: 'Name', field: 'Name', sortable: true, defaultValue: 0, editView: valueView("text")},
        {title: 'File', field: 'NewLevel', sortable: true, defaultValue: 0, editView: binaryView("json", "LevelData")},
        {title: 'Updated At', field: 'UpdatedAt', sortable: true, defaultValue: new Date(), editView: dateView},
        {title: 'Hidden', field: 'Hidden', sortable: true, defaultValue: true, editView: valueView("checkbox")},
        {title: 'Is Multiplayer', field: 'Multiplayer', sortable: true, defaultValue: false, editView: valueView("checkbox")},
    ];

    onMount(load)
</script>
<RoundWrapper>
    <StraightTable data={rows} {columns} on:change={save}/>
</RoundWrapper>

<style>
    td, th {
        @apply p-2
    }

    table {
        @apply mb-2
    }
</style>
